import React, { ReactNode, useState } from 'react';
import { Icon, SubHeader } from 'vetrf-ui';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import styles from './FiltersWrapper.module.scss';

type FiltersWrapperProps = {
  children: ReactNode;
};

export const FiltersWrapper = ({ children }: FiltersWrapperProps) => {
  const [expanded, setExpanded] = useState(true);

  const handleChange = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion className={styles.filterBlock} expanded={expanded} onChange={handleChange}>
      <AccordionSummary
        expandIcon={<Icon icon="chevron-up" />}
        className={styles.filterBlockHeader}
      >
        <SubHeader header="Поиск" level={4} />
        <div className={styles.filterBlockCounter}>{/* 5 */}</div>
      </AccordionSummary>
      <AccordionDetails className={styles.filterBlockBody}>{children}</AccordionDetails>
    </Accordion>
  );
};
